import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {NotificationAccountList} from "../../models/notificationAccountList";
import {NotificationAccountService} from "../../services/notificationAccount.service";

@Injectable()
export class NotificationAccountListResolve implements Resolve<NotificationAccountList> {
    constructor(private notificationAccountService: NotificationAccountService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<NotificationAccountList> {
        return this.notificationAccountService.getAll(0, 100);
    }
}
